  // 列表组件
  import React, {useContext, useEffect, useRef, useState} from 'react';
  import { useTranslation } from "@/langs/useTranslation";
  import {  Table, Checkbox } from 'antd';
  import {
    Button,
  } from "@material-ui/core";
  import DeviceTableColumnsManagerModal from '@/containers/StoreManagement/DeviceTableColumnsManager/Modal';
  import {SettingOutlined} from "@ant-design/icons"
  import StoreApi from '@/apis/storeAPI';
  import _ from 'lodash';
  import {LanguageContext} from '@/langs/LanguageContext';
  import {useGroupUsersState} from '@/containers/GroupsUsers/Provider';

  const TableList = ({
    selectedRowKeys,
    tableLoading,
    pageSetting={
      page:0,
      page_size: 20,
      total: 0,
      order_by_column: null,// 排序相关
      order_by_desc: null
    },
    checkedAll,
    userGroupsData,
    tableData,
    tableFunc,
  }) => {
    // table ref
    const tableRef = useRef(null)
    // 多语言
    const userLang = useTranslation("user");
    // 列设置弹窗
    const [columnsManagerModalOpen,setColumnsManagerModalOpen] = useState(false)
    // 使用的列数据
    const [columns,setColumns] = useState([])
    // 缓存的列数据
    const [defaultColumns, setDefaultColumns] = useState([])

    const contextValue = useContext(LanguageContext);

    const { currentGroup, loadingGroup,currentCompanyId } = useGroupUsersState();

    const handleColumnsClose = () => {
      setColumnsManagerModalOpen(false);
    };
    const handleColumnsConfirm = async(data) => {
      const requestData = _.map(_.filter(data,d=>!d.invisible),item=>{
        return {
          field: item.key,
          show: item.visible
        }
      })
      // const field = [{"field":"store_name","show":true},{"field":"store_code","show":true},{"field":"status","show":true},{"field":"invisible_user_count","show":true},{"field":"devices_count","show":true},{"field":"name","show":true},{"field":"parent_name","show":true},{"field":"store_address","show":true},{"field":"contact","show":true},{"field":"contact_phone","show":true}]

      const res = await StoreApi.SetTableColumnConfig({
        table: "groups",
        list_fields: requestData
      })

      if(res.status === "success") {
        setTableColumn()
      }

      setColumnsManagerModalOpen(false)

    }

    const defaultColumnsSetting = [
      {
        title: `${userLang.t({defaultMessage: '姓名'})}`,
        ellipsis: true,
        dataIndex: 'name',
        key: 'name',
        align: 'left',
        width: 220,
        visible: true,
        sortOrder: pageSetting.order_by_column === 'name' ? pageSetting.order_by_desc : '',
        render: (_,record) => {
          return record.name
        },
      },
      {
        title: `${userLang.t({defaultMessage: '手机'})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'phone',
        disabled: 'true',
        key: 'phone',
        width: 180,
        align: 'left',
        sortOrder: pageSetting.order_by_column === 'phone' ? pageSetting.order_by_desc : '',
        render: (text,record) => {
          return record.phone
        },
      },
      {
        title: `${userLang.t({defaultMessage: '邮箱'})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'email',
        key: 'email',
        width: 220,
        align: 'left',
        sortOrder: pageSetting.order_by_column === 'email' ? pageSetting.order_by_desc : '',
        render: (text,record) => {
          return record.email
        },
      },
      {
        title: `${userLang.t({defaultMessage: '角色'})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'role_name',
        width: 120,
        key: 'role_name',
        sortOrder: pageSetting.order_by_column === 'role_name' ? pageSetting.order_by_desc : '',
        render: (text,record) => {
          return record.role.name
        },
      },
      {
        title: `${userLang.t({defaultMessage:"门店"})}`,
        ellipsis: true,
        visible: true,
        dataIndex: 'devices_count',
        key: 'devices_count',
        align: 'center',
        width: 80,
        render: (text,record) => {
          const count = userGroupsData.length - record.invisibleGroups.length;
          return count >0 ?(<a onClick={()=>{tableFunc.handleChangeStore(record)}}>{count}</a>) : count;
        },
      },
      {
        title: `${userLang.t({defaultMessage: '状态'})}`,
        ellipsis: true,
        visible: true,
        fixed: 'right',
        dataIndex: 'activeStatus',
        key: 'activeStatus',
        align: 'center',
        width: 100,
        render: (text,record) => {
          return record.activeStatus ? userLang.t({ defaultMessage: "激活" }) : userLang.t({ defaultMessage: "未激活" });
        },
      },
      {
        title: `${userLang.t({defaultMessage:"2FA"})}`,
        ellipsis: true,
        visible: true,
        fixed: 'right',
        dataIndex: 'otpRequired',
        key: 'otpRequired',
        align: 'center',
        width: 100,
        render: (text,record) => {
          return record.otpRequired ? userLang.t({ defaultMessage: "开启" }) : userLang.t({ defaultMessage: "未开启" });
        },
      }
    ]

    const defaultColumnsOperationSetting = []
    // 获取当前数据库中存储的字段顺序值
    const getTableColumn = async () => {
      // 获取云端数据
      // const serverColumnSetting = await StoreApi.GetTableColumnConfig({
      //   table: 'groups'
      // })
      let reloadColumns = []
      // if(serverColumnSetting.config && serverColumnSetting.config.length>0){
      //   // 进行本地和云端进行排序
      //   _.each(serverColumnSetting.config,serverItem=>{
      //     const localItem = _.find(defaultColumnsSetting,localItem=> localItem.key === serverItem.field)
      //     if(localItem) reloadColumns.push({
      //       ...localItem,
      //       visible: serverItem.show
      //     })
      //   })
      // }else {
      //   reloadColumns = defaultColumnsSetting
      // }
      reloadColumns = defaultColumnsSetting
      // 操作追加到最后
      reloadColumns = reloadColumns.concat(defaultColumnsOperationSetting)
      return reloadColumns
    }

    const setTableColumn = async() => {
      // 通过云端的数据进行重新排序和收藏
      const reloadColumns = await getTableColumn()
      setDefaultColumns(_.cloneDeepWith(defaultColumnsSetting.concat(defaultColumnsOperationSetting),true))
      setColumns(_.cloneDeepWith(reloadColumns,true))
    }

    useEffect(()=>{
      setTableColumn()
      // setOrderByColumn(pageSetting.order_by_column)
    },[pageSetting,contextValue,userGroupsData])


    return <>
      <Table ref={tableRef}
             rowKey="id"
             columns={columns.filter(v => v.visible)}
             dataSource={tableData}
             onChange={tableFunc.onChange}
             loading={tableLoading}
             rowSelection={{
               fixed : true,
               selectedRowKeys: selectedRowKeys,
               type: "checkbox",
               onChange: tableFunc.onSelectChange,
               preserveSelectedRowKeys: true
             }}
             scroll={{y: '200' }}
             pagination={{
               simple: false,
               current: pageSetting.page,
               pageSize: pageSetting.page_size,
               showSizeChanger: true,
               showTotal : (total) => `${userLang.t({defaultMessage: "共{total}条"},{total: total}) }`,
               total:pageSetting.total
             }}
             footer={()=>{
               return <div className={`my-table-footer`}>
                 {/*<Checkbox checked={checkedAll} onChange={tableFunc.handleChangeCheckedAll}>{userLang.t({defaultMessage: '全选'})}</Checkbox>*/}
                 <Button variant="outlined" color="primary" size="small" onClick={()=> {tableFunc.handleTransferGroup()}}>
                   {userLang.t({defaultMessage: '归属门店'})}
                 </Button>

                 {
                   (currentGroup && currentGroup.id !== "all") && <Button variant="outlined" color="secondary" size="small" onClick={()=> { tableFunc.handleRemoveGroup()}}>
                    {userLang.t({defaultMessage: '移出门店'})}
                   </Button>
                 }
               </div>
             }}
      />
      <DeviceTableColumnsManagerModal
        list={columns}
        getDefaultColumns={()=>{return defaultColumns}}
        open={columnsManagerModalOpen}
        onClose={handleColumnsClose}
        onConfirm={handleColumnsConfirm}
      />
    </>
  }
  export default React.memo(TableList)
